const SessionTypes = {
  WEB_REMEMBER_ME: 'WEB_REMEMBER_ME',
} as const
type SessionType = (typeof SessionTypes)[keyof typeof SessionTypes]

export interface Session {
  id: number
  type: SessionType
  operatingSystem: string
  browser: string
  device: string
  lastIpAddress: string
  lastLoginAt: number
  location: string
}

export type GetSessionsResponseBody = Session[]

export interface DeleteSessionRequest {
  params: {
    id: number
    type: SessionType
  }
}
